import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import Card from "./card";
import "swiper/css";
import "./winner.css";
import { ArrowLeftCircle, ArrowRightCircle } from "lucide-react";
import "swiper/css/effect-fade";
import CardSkeleton from "./Card-Skeleton";
import { useWinnersCtx } from "@/contexts/winners";
import { Skeleton } from "@/components/ui/skeleton";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

function NavigationButtons() {
  const swiper = useSwiper();
  const [isBeginning, setIsBeginning] = useState(true);

  useEffect(() => {
    const handleSwiperChange = () => {
      setIsBeginning(swiper.isBeginning);
    };

    swiper.on("slideChange", handleSwiperChange);

    return () => {
      swiper.off("slideChange", handleSwiperChange);
    };
  }, [swiper]);

  return (
    <div className="absolute z-10 flex gap-1 ltr:right-0 ltr:top-0 rtl:left-0 rtl:top-0">
      <ArrowLeftCircle
        strokeWidth={1}
        size={32}
        className={cn(
          "cursor-pointer text-secondary",
          isBeginning ? "cursor-not-allowed opacity-40" : "",
          "ltr:rotate-0 rtl:rotate-180", // Rotate for RTL
        )}
        onClick={() => !isBeginning && swiper.slidePrev()}
      />
      <ArrowRightCircle
        strokeWidth={1}
        size={32}
        className={cn(
          "cursor-pointer text-secondary",
          "ltr:rotate-0 rtl:rotate-180", // Rotate for RTL
        )}
        onClick={() => swiper.slideNext()}
      />
    </div>
  );
}

export default function SlideShowSwiper({ winners }: any) {
  const { loading } = useWinnersCtx();
  // const [slideEnd, setSlideEnd] = useState(false);

  if (winners.length === 0 || loading) {
    return (
      <div className="hidden lg:block">
        <Swiper spaceBetween={12} slidesPerView={7}>
          <div className="absolute z-10 flex gap-1 ltr:right-0 ltr:top-0 rtl:left-0 rtl:top-0 rtl:flex-row-reverse">
            <Skeleton className="h-8 w-8" />
            <Skeleton className="h-8 w-8" />
          </div>
          {Array.from({ length: 7 }).map((_, index) => (
            <SwiperSlide key={index}>
              {({ isActive }) => <CardSkeleton isSelected={isActive} />}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }

  const placeholders = Array(10).fill(null);

  return (
    <div className="hidden lg:block">
      <Swiper
        spaceBetween={12}
        slidesPerView={7}
        initialSlide={1}
        onSlideChange={(swiper) => {
          const currentSlide = swiper.activeIndex;
          if (currentSlide === winners.length - 1) {
            // setSlideEnd(true);
          } else {
            // setSlideEnd(false);
          }
          if (currentSlide >= winners.length) {
            swiper.slideTo(0);
          }
        }}
      >
        <NavigationButtons />
        {winners.map((winner: any, index: number) => (
          <SwiperSlide key={index}>
            {({ isActive }) => (
              <Card key={index} isSelected={isActive} {...winner} />
            )}
          </SwiperSlide>
        ))}

        {placeholders.map((_, index) => (
          <SwiperSlide key={`placeholder-${index}`}>
            <div className="flex h-full items-center justify-center">
              <div style={{ visibility: "hidden" }}>Empty Slide</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
